import { Component, OnInit } from '@angular/core';
import { IContentFindResponse } from '../../store/models/content.model';

@Component({
  selector: 'app-confirm-reset-content',
  templateUrl: './confirm-reset-content.component.html',
  styleUrls: ['./confirm-reset-content.component.scss'],
})
export class ConfirmResetContentComponent implements OnInit {

  contents: IContentFindResponse[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  getContent(template: string): IContentFindResponse {
    return this.contents.find(c => c.content_template === template);
  }

}
